import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import BusinessTripHead from '@/types/table/businessTripHead';
import BusinessTripDetailReport from '@/types/table/businessTripDetailReport';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface BusinessTripHeadData extends BusinessTripHead {
  __cascade_add_temp_id__?: string | number | undefined;
}

export type BusinessTripDetailReportData = BusinessTripDetailReport;

export default class BusinessTripHeadController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<BusinessTripHeadData>>(
      API_CONTEXT + '/app/businessTripHead/list',
      params,
      httpOptions,
    );
  }
  /** 出差申请明细报表（分页，与后端 detailReportList 一致） */
  static detailReportList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<BusinessTripDetailReportData>>(
      API_CONTEXT + '/app/businessTripHead/detailReportList',
      params,
      httpOptions,
    );
  }

  /** 出差申请明细报表导出（与 detailReportList 相同筛选；exportAll 为 false 时仅当前页） */
  static detailReportExport(params: ANY_OBJECT, fileName: string) {
    return super.download(
      API_CONTEXT + '/app/businessTripHead/detailReportExport',
      params,
      fileName,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<BusinessTripHeadData>(
      API_CONTEXT + '/app/businessTripHead/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/businessTripHead/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/businessTripHead/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/businessTripHead/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/businessTripHead/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/businessTripHead/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/businessTripHead/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/businessTripHead/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/app/businessTripHead/startOnly/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static startWithBusinessKeyFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/app/businessTripHead/startWithBusinessKey/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static startAndTakeUserTaskFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/app/businessTripHead/startAndTakeUserTask/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static startAndSaveDraftFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/app/businessTripHead/startAndSaveDraft/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static submitUserTaskFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/app/businessTripHead/submitUserTask/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static viewTaskBusinessDataFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(
      API_CONTEXT + '/app/businessTripHead/viewTaskBusinessData/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static viewHistoricTaskBusinessDataFlowBusinessTrip(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/app/businessTripHead/viewHistoricTaskBusinessData/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  static listWorkOrderFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/app/businessTripHead/listWorkOrder/flowBusinessTrip',
      params,
      httpOptions,
    );
  }
  /** 报表/打印：发布数据集（与后端 publishedDataSet 一致，body 传 businessKey） */
  static publishedDataSet(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<ANY_OBJECT>(
      API_CONTEXT + '/app/businessTripHead/publishedDataSet',
      params,
      httpOptions,
    );
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
